import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type StatisticsSummaryQuery = z.output<typeof statisticsSummaryQuerySchema>;
export type StatisticsSummaryQueryDTO = z.input<typeof statisticsSummaryQuerySchema>;

export const statisticsSummaryQuerySchema = z.object({
  from: isoDatetimeToDate.optional(),
  to: isoDatetimeToDate.optional(),
  diff_from: isoDatetimeToDate.optional(),
  diff_to: isoDatetimeToDate.optional(),
  /** Restricts the summary to the players of a group; the whole team when absent. */
  groupId: z.uuid().nullish().catch(null),
});
